/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
(() => {
	const siteName = 'default-package';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 140,
				sp: 60
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});

					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');

				// Apply initial rotation for already open accordions
				if (ele.hasAttribute('open') && plus) {
					plus.animate(
						{ rotate: ['0deg', '90deg'] },
						{
							duration: 0,
							pseudoElement: "::after",
							easing: 'ease',
							fill: 'forwards',
						}
					);
				}

				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						if (plus) {
							plus.animate(
								{ rotate: ['90deg', '0deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						}
						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						if (plus) {
							plus.animate(
								{ rotate: ['0deg', '90deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						}
					}
				});
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');

			// Extract prefix from data-target (e.g., "tabContent" from "tabContent01")
			const getPrefix = (target) => {
				return target.replace(/\d+$/, '');
			};

			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						const clickedTarget = ele.getAttribute('data-target');
						const prefix = getPrefix(clickedTarget);

						// Only remove active class from tabs in the same group
						$tab.forEach(ele2 => {
							const targetPrefix = getPrefix(ele2.getAttribute('data-target'));

							if (targetPrefix === prefix) {
								ele2.classList.remove(a);
							}
						});

						ele.classList.add(a);

						// Only remove active class from content in the same group
						$content.forEach(ele2 => {
							const contentPrefix = getPrefix(ele2.getAttribute('data-target'));
							if (contentPrefix === prefix) {
								ele2.classList.remove(a);
								ele2.classList.remove(v);
							}
						});

						let $target;
						let target = clickedTarget;
						if (target === 'all') {
							// For 'all', only affect content with the same prefix
							$target = Array.from($content).filter(item => {
								return getPrefix(item.getAttribute('data-target')) === prefix;
							});
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}

						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			const _this = this;
			const scrollToObject = (_self) => {
				const href = _self.currentTarget.href;
				const hash = href.split('#')[1];

				if (!hash) return;

				let pos = 0;

				if (hash !== 'pagetop') {
					const targetEl = document.getElementById(hash);
					if (!targetEl) return;

					const rectTop = targetEl.getBoundingClientRect().top;
					const scrollY = window.scrollY;

					// margin-top を取得
					const style = window.getComputedStyle(targetEl);
					const marginTop = parseFloat(style.marginTop) || 0;

					// ヘッダーの高さを取得
					const headerOffset = FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp
						? FUNCTIONS.va.header.sp
						: FUNCTIONS.va.header.desktop;

					// スクロール位置を計算（marginも引く）
					pos = rectTop + scrollY - headerOffset - marginTop;
				}

				window.scrollTo({
					top: pos,
					behavior: 'smooth',
				});
			};

			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if (focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};

			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					_this.closeSpHeaderNav();
					if (/#/.test(e.currentTarget.href)) {
						scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							document.getElementById(hash).querySelectorAll(focusableElementsSelector)
						);
						if (focusableElements.length) {
							focusableElements[0].focus();
						}
					}
				}
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
							resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}
				window.addEventListener('load', async () => {
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						let pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
					await waitForScrollComplete(hash);
				});
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		setModal() {
			const createModal = (_appendHTML, _target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if (document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
									document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
									if (focusedItemIndex === 0) {
										// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
										focusableElements[focusableElements.length - 1].focus();
									} else {
										// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
										focusableElements[focusedItemIndex - 1].focus();
									}
								} else {
									if (focusedItemIndex === focusableElements.length - 1) {
										// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
										focusableElements[0].focus();
									} else {
										// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
										focusableElements[focusedItemIndex + 1].focus();
									}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML, e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化

			$elements.forEach(ele => {
				const attributeName = ele.getAttribute('data-mh');
				if (!groups.has(attributeName)) {
					groups.set(attributeName, []);
				}
				groups.get(attributeName).push(ele);
			});
			groups.forEach(group => {
				const attributeGroups = new Map();
				const TOLERANCE = 5; // 許容範囲（±5px）

				group.forEach(ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;

					// 許容範囲に合わせて丸める
					const roundedTop = Math.round(topPosition / TOLERANCE) * TOLERANCE;
					const key = attributeName + '_' + roundedTop;

					if (!attributeGroups.has(key)) {
						attributeGroups.set(key, []);
					}
					attributeGroups.get(key).push(ele);
				});
				attributeGroups.forEach((item) => {
					const maxHeight = Math.max(...item.map(ele => ele.offsetHeight));
					item.forEach((ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			});
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if (document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素やその子要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');

			// 要素が空かどうかを再帰的に確認する関数
			const isElementEmpty = (element) => {
				// テキストを正規化 (空白を削除)
				const hasText = element.textContent.trim().length > 0;
				if (hasText) return false;

				// 子要素をチェック
				const children = element.children;
				if (children.length === 0) return true;

				// すべての子要素が空かどうかをチェック
				for (let i = 0; i < children.length; i++) {
					if (!isElementEmpty(children[i])) {
						return false;
					}
				}

				return true;
			};

			$eleList.forEach(ele => {
				if (isElementEmpty(ele)) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty() {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li')) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		URLcurrent() {
			if (document.querySelector('.js-current')) {
				document.querySelectorAll('.js-current').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
					if (currentPath == linkPath) {
						item1.classList.add(a);
					}
				});
			}
		},
		addClassHeader() {
			let _this = this;
			if (document.querySelector('.header') && !document.querySelector('.header-restaurant.header')) {
				const $header = document.querySelector('.header');
				const $headerHeight = $header.offsetHeight;
				let lastScrollPosition = 0;

				window.addEventListener('scroll', () => {
					const currentScrollPosition = window.scrollY;
					const isBodyFixed = document.body && document.body.style.position === 'fixed';
					// スクロール方向を判定
					if (!isBodyFixed) {
						if (currentScrollPosition > lastScrollPosition) {
							// 下方向へのスクロール
							$header.classList.add("is-scrolling-down");
							$header.classList.remove("is-scrolling-up");
						} else {
							// 上方向へのスクロール
							$header.classList.add("is-scrolling-up");
							$header.classList.remove("is-scrolling-down");
							_this.setElementHeight();
						}
					}

					// スクロール位置に基づくクラス
					// bodyにposition:fixedが設定されていない場合のみ制御

					if (!isBodyFixed) {
						if (currentScrollPosition > $headerHeight) {
							$header.classList.add("is-scrolled");
						} else {
							$header.classList.remove("is-scrolled");
						}
					}

					// 現在のスクロール位置を記録
					lastScrollPosition = currentScrollPosition;

				});
			}
		},
		pcHeaderMegamenu() {
			if (document.querySelectorAll('.js-header-nav-mega').length && !document.querySelector('.header-restaurant')) {
				const $header = document.querySelector('.header');
				const $megabtn = document.querySelectorAll('.js-header-nav-mega-btn');
				const $megamenu = document.querySelectorAll('.js-header-nav-mega-contents');
				const closeAllMegaMenus = () => {

					$header.classList.remove(a);
					$header.classList.remove('is-open'); // Remove open class when closing menus
					$megabtn.forEach(btn => {
						btn.classList.remove(a);
						if (btn.nextElementSibling) {
							btn.nextElementSibling.classList.remove(a);
						}
					});
				};

				// メガメニューの初期化
				const currentPath = location.pathname;

				// ディレクトリ設定に基づくタブの初期化
				const directoryGroups = [
					{ paths: ['/', '/business/', '/about/', '/sustainability/', '/news/', '/contact/', '/terms/', '/privacy/', '/exclusion_antisocial/', '/sitemap/', '/definition_of_customer_harassment/', '/error'], tabTarget: 'headerTab01' },
					{ paths: ['/service/'], tabTarget: 'headerTab02' },
					{ paths: ['/gekkan-huge/'], tabTarget: 'headerTab03' }
				];

				directoryGroups.forEach(group => {
					const isMatchingPath = group.paths.some(path => {
						if (path === '/') {
							// For root path, match only exact root or /index.html (including /en/)
							return currentPath === '/' || currentPath === '/index.html' ||
								currentPath === '/en/' || currentPath === '/en/index.html';
						} else {
							// For other paths, match only first-level directories
							// Remove trailing slash for comparison
							const normalizedPath = path.replace(/\/$/, '');
							const pathSegments = currentPath.split('/').filter(segment => segment !== '');
							const targetSegments = normalizedPath.split('/').filter(segment => segment !== '');

							// Handle /en/ prefix
							const hasEnPrefix = pathSegments[0] === 'en';
							const actualSegments = hasEnPrefix ? pathSegments.slice(1) : pathSegments;

							// Only match if the path segments match exactly (first level only)
							return actualSegments.length > 0 &&
								targetSegments.length > 0 &&
								actualSegments[0] === targetSegments[0];
						}
					});



					if (isMatchingPath) {
						// タブボタンにis-activeを追加
						const headerTabBtn = document.querySelector(`[data-target="${group.tabTarget}"]`);
						if (headerTabBtn) {
							headerTabBtn.classList.add(a);
							const headerTabContents = headerTabBtn.nextElementSibling;
							if (headerTabContents) {
								headerTabContents.classList.add(a);
							}
						}

						// .js-tab-contentからdata-targetを検索し、対応するものにis-activeとis-visibleをつける
						const headerTabContent = document.querySelector(`.js-tab-content[data-target="${group.tabTarget}"]`);
						if (headerTabContent) {
							headerTabContent.classList.add(a);
							headerTabContent.classList.add(v);
						}

						// ディレクトリとテキストに基づくis-currentクラスの付与
						const directoryTextMappings = [
							{ paths: ['/', '/en/'], text: 'TOP', exactMatch: true },
							{ paths: ['/service/', '/en/service/'], text: 'TOP', exactMatch: true },
							{ paths: ['/gekkan-huge/', '/en/gekkan-huge/'], text: 'TOP', exactMatch: true },

							{ paths: ['/about/', '/en/about/'], text: 'ABOUT US' },
							{ paths: ['/business/', '/en/business/'], text: 'BUSINESS' },
							{ paths: ['/news/', '/en/news/'], text: 'NEWS' },
							{ paths: ['/sustainability/', '/en/sustainability/'], text: 'SUSTAINABILITY' },

							{ paths: ['/service/restaurant/', '/en/service/restaurant/'], text: 'RESTAURANT' },
							{ paths: ['/service/party/', '/en/service/party/'], text: 'WEDDING&EVENT' },
							{ paths: ['/service/product/', '/en/service/product/'], text: 'PRODUCT' },
							{ paths: ['/service/product/news/', '/en/service/product/news/'], text: 'NEWS' },

							{ paths: ['/gekkan-huge/gekkan_hospital/', '/en/gekkan-huge/gekkan_hospital/'], text: 'HUGE-ISH HOSPITALITY' },
							{ paths: ['/gekkan-huge/gekkan_philosophy/'], text: '食のこだわり' },
							{ paths: ['/en/gekkan-huge/gekkan_philosophy/'], text: 'What We Serve, and Why' },
							{ paths: ['/gekkan-huge/gekkan_other_huge/', '/en/gekkan-huge/gekkan_other_huge/'], text: 'OTHER' },
						];

						directoryTextMappings.forEach(mapping => {
							const isMatchingPath = mapping.paths.some(path => {

								if (mapping.exactMatch) {
									// 完全一致の場合
									const normalizedCurrentPath = currentPath.replace(/index\.html$/, '');
									const normalizedPath = path.replace(/\/$/, '');
									return normalizedCurrentPath === normalizedPath || normalizedCurrentPath === normalizedPath + '/';
								} else {
									// 部分一致の場合
									return currentPath.includes(path.replace(/\/$/, ''));
								}
							});

							if (isMatchingPath) {
								const headerTabContentElements = headerTabContent.querySelectorAll('a,button');

								headerTabContentElements.forEach(element => {

									if (element.textContent.trim().includes(mapping.text)) {
										element.classList.add('is-current');
									}
								});
							}
						});
					}
				});

				// メガメニューボタンのクリックイベント処理
				$megabtn.forEach(btn => {
					btn.addEventListener('click', (e) => {
						const clickedBtn = e.currentTarget;
						const clickedNav = clickedBtn.nextElementSibling; // 対応する .header-nav-pc
						// 他のメガメニューを閉じる
						$megabtn.forEach(otherBtn => {
							if (otherBtn !== clickedBtn) {
								otherBtn.classList.remove(a);
								if (otherBtn.nextElementSibling) {
									otherBtn.nextElementSibling.classList.remove(a);
								}
							}
						});
						// クリックされたメガメニューの開閉
						if (clickedBtn.classList.contains(a)) {
							$header.classList.remove(a);
							$header.classList.remove('is-open'); // Remove open class when closing menu
							clickedBtn.classList.remove(a);
							// clickedNavが存在することを確認してから操作
							if (clickedNav) {
								clickedNav.classList.remove(a);
							}
						} else {
							$header.classList.add(a);
							$header.classList.add('is-open'); // Add open class when opening menu
							clickedBtn.classList.add(a);
							if (clickedNav) {
								clickedNav.classList.add(a);
							}
						}
					});
				});
				// メガメニュー外のクリックまたは閉じるボタンのクリックで閉じる
				document.addEventListener("click", (event) => {
					const target = event.target;
					const isClickInsideNav = [...$megamenu]
						.some(el => el.contains(target));
					const isClickOnButton = [...$megabtn]
						.some(btn => btn.contains(target));
					const isClickOnCloseButton = target.closest('.js-header-nav-mega-close-btn');
					const isClickOnTabButton = target.closest('.js-tab') && [...$megamenu]
						.some(el => el.contains(target.closest('.js-tab')));


					if (isClickOnCloseButton || (!isClickInsideNav && !isClickOnButton && $header.classList.contains(a))) {
						if (!isClickOnTabButton) {

							closeAllMegaMenus();
						}
					}
				});
				// フォーカスが外れた時のメニュー制御を追加
				$megabtn.forEach(btn => {
					const menu = btn.nextElementSibling;
					if (menu) {
						// フォーカスが .header-nav-pc 内にあるかチェックする関数
						const isInsideAnyHeaderNav = (element) => {
							return Array.from($megamenu).some(headerNav => headerNav.contains(element));
						};
						// フォーカスが外れた時にメニューを閉じる
						menu.addEventListener('focusout', () => {
							setTimeout(() => {
								const focusedElement = document.activeElement;
								const isInsideNav = menu.contains(focusedElement);
								const isInsideButton = btn.contains(focusedElement);
								const isInsideHeaderNav = isInsideAnyHeaderNav(focusedElement);
								// .header-nav-pc 内にフォーカスがない場合に閉じる
								if (!isInsideNav && !isInsideButton && !isInsideHeaderNav) {

									// closeAllMegaMenus();
								}
							}, 0);
						});
						// TabキーまたはShift+Tabで移動した際にメニューを閉じる
						document.addEventListener('keydown', (e) => {
							if (e.key === 'Tab') {
								setTimeout(() => {
									const focusedElement = document.activeElement;
									const isInsideNav = menu.contains(focusedElement);
									const isInsideButton = btn.contains(focusedElement);
									const isInsideHeaderNav = isInsideAnyHeaderNav(focusedElement);
									// .header-nav-pc 内にフォーカスがない場合に閉じる
									if (!isInsideNav && !isInsideButton && !isInsideHeaderNav) {
										closeAllMegaMenus();
									}
								}, 0);
							}
						});
					}
				});
				// ESCキーでメガメニューを閉じる
				window.addEventListener("keydown", function (event) {
					if ($header.classList.contains(a)) {
						if (event.key === "Escape") {
							event.preventDefault();
							closeAllMegaMenus();
						}
					}
				});
			}

			// .js-header-restaurantをクリックしたときのイベント登録
			document.querySelectorAll('.js-header-restaurant').forEach(btn => {
				btn.addEventListener('click', (e) => {
					let _btn = e.currentTarget

					const rtCfTbCodeElement = _btn.querySelector('.rt_cf_tb_code');
					if (rtCfTbCodeElement) {
						const brandCode = rtCfTbCodeElement.textContent.trim();

						if (brandCode) {

							const currentTabContent = document.querySelector('.js-header-restaurant-tab-content');
							if (currentTabContent) {
								const tabContentInner = currentTabContent.querySelector('.__tabContentInner');
								if (tabContentInner) {
									tabContentInner.innerHTML = '';
								}
							}
							const tabContentInnerSP = document.querySelector('.js-header-restaurant-tab-content-sp');
							if (tabContentInnerSP) {
								tabContentInnerSP.innerHTML = '';
							}

							let apiUrl = `/ajax/header/${brandCode}/tenpo_list.json`;
							fetch(apiUrl)
								.then(response => response.json())
								.then(data => {


									if (!data || !data.rt_bn_tenpo_list || data.rt_bn_tenpo_list.length === 0) {
										return;
									}

									// let _data = data.rt_bn_tenpo_list;
									// 押されたボタンの情報を取得
									const buttonImg = _btn.querySelector('img');
									const buttonEnText = _btn.querySelector('.__en')?.textContent;
									const buttonJaText = _btn.querySelector('.__ja')?.textContent;

									// 英語版パスかどうかを判定
									const isEnglishPath = location.pathname.startsWith('/en/');

									// URLのベースパスを決定
									let basePath = isEnglishPath ? '/en' : '';
									basePath += '/service/restaurant/' + brandCode + '/';

									let mvHtml = '';
									if (buttonImg && buttonEnText && buttonJaText) {
										mvHtml = `
												<div class="__mv js-header-restaurant-mv">
													<a href="${basePath}">
														<figure>
															<img src="${buttonImg.src}" alt="${buttonImg.alt}" width="640" height="240">
														</figure>
														<div class="__title ff_alphabet">
															<span>${buttonEnText}</span>
															<span>${buttonJaText}</span>
														</div>
														<svg class="_right" aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right"></use></svg>
													</a>
												</div>
											`;
									}

									// 店舗リストのHTMLを生成
									let listHtml = '<div class="__list js-header-restaurant-list">';
									data.rt_bn_tenpo_list.forEach(tenpo => {
										const isEnPath = location.pathname.startsWith('/en/');

										listHtml += `
											<a href="${basePath + tenpo._key + '/'}" class="header-nav-mega-link">
												<figure><img src="/tenpo_file/file/${isEnPath ? (tenpo.cf_t_thum_img_en || '') : (tenpo.cf_t_thum_img_jp || '')}" loading="lazy" alt="${isEnPath ? (tenpo.cf_t_thum_img_alt_en || '') : (tenpo.cf_t_thum_img_alt_jp || '')}" title="${isEnPath ? (tenpo.cf_t_thum_img_title_en || '') : (tenpo.cf_t_thum_img_title_jp || '')}" width="120" height="80"></figure>
												<div>
													<div class="__area">
														<span class="__label">${isEnPath ? (tenpo.cf_t_erea_en || '') : (tenpo.cf_t_erea_jp || '')}</span>
														<p>${isEnPath ? (tenpo.cf_t_catch_copy_en || '') : (tenpo.cf_t_catch_copy_jp || '')}</p>
													</div>
													<span class="__en">${tenpo.cf_t_name_en || ''}</span>
													${!isEnPath ? `<span class="__ja">${tenpo.cf_t_name_jp || ''}</span>` : ''}
												</div>
												<svg class="_right" aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right"></use></svg>
											</a>`;
									});
									listHtml += '</div>';

									// HTMLを結合してモーダルまたは表示領域に挿入
									let finalHtml = mvHtml + listHtml;

									// 現在の.__tabContentを取得
									const currentTabContent = document.querySelector('.js-header-restaurant-tab-content');

									if (currentTabContent) {
										const tabContentInner = currentTabContent.querySelector('.__tabContentInner');
										if (tabContentInner) {

											tabContentInner.innerHTML = finalHtml;
										}
									}


									// SP用記述

									mvHtml = '';
									if (buttonImg && buttonEnText && buttonJaText) {
										mvHtml = `
											<div class="__mv mod-spacer">
												<a href="${basePath}">
													<figure>
														<img src="${buttonImg.src}" loading="lazy" alt="${buttonImg.alt}" width="640" height="240">
													</figure>
													<div class="__title">
														<span>${buttonEnText}</span>
														<span>${buttonJaText}</span>
													</div>
													<svg class="_right" aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right"></use></svg>
												</a>
											</div>
										`;
									}

									listHtml = '<div class="__list mod-spacer_24">';
									data.rt_bn_tenpo_list.forEach(tenpo => {
										const isEnPath = location.pathname.startsWith('/en/');

										listHtml += `
											<a href="${basePath + tenpo._key + '/'}" class="header-nav-mega-link">
												<img src="/tenpo_file/file/${isEnPath ? (tenpo.cf_t_thum_img_en || '') : (tenpo.cf_t_thum_img_jp || '')}" loading="lazy" alt="${isEnPath ? (tenpo.cf_t_thum_img_alt_en || '') : (tenpo.cf_t_thum_img_alt_jp || '')}" width="120" height="80">
												<div>
													<div class="__area">
														<span class="__label">${isEnPath ? (tenpo.cf_t_erea_en || '') : (tenpo.cf_t_erea_jp || '')}</span>
														<p>${isEnPath ? (tenpo.cf_t_catch_copy_en || '') : (tenpo.cf_t_catch_copy_jp || '')}</p>
													</div>
													<span class="__en">${tenpo.cf_t_name_en || ''}</span>
													${!isEnPath ? `<span class="__ja">${tenpo.cf_t_name_jp || ''}</span>` : ''}
												</div>
												<svg class="_right" aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right"></use></svg>
											</a>`;
									});
									listHtml += '</div>';
									// 現在の.__tabContentを取得
									finalHtml = mvHtml + listHtml;
									const tabContentInnerSP = document.querySelector('.js-header-restaurant-tab-content-sp');
									if (tabContentInnerSP) {
										tabContentInnerSP.innerHTML = finalHtml;
									}




								})
								.catch(error => {
									console.error('Failed to load restaurant data:', error);
								});

						}
					}
				});
			});

			// .js-header-menuのmouseenterは各メニューに、mouseleaveは.headerに登録
			const header = document.querySelector('.header');
			// .headerがあり、かつ.header-restaurant.headerが無い場合のみ処理
			if (header && !document.querySelector('.header-restaurant.header')) {
				document.querySelectorAll('.js-header-menu').forEach(menu => {
					menu.addEventListener('mouseenter', (e) => {
						const target = menu.getAttribute('data-target');
						if (!target) return;
						// .header内のすべてのjs-tab-contentからis-active/is-visibleを外す
						document.querySelectorAll('.header .js-tab-content').forEach(content => {
							content.classList.remove('is-active', 'is-visible');
						});
						// .header内の対象のjs-tab-contentにis-active/is-visibleを付与
						document.querySelectorAll(`.header .js-tab-content[data-target="${target}"]`).forEach(content => {
							content.classList.add('is-active');
							setTimeout(() => content.classList.add('is-visible'), 10);
						});
						// すでに .js-header-menu.is-hover があれば外す
						const prevHover = document.querySelector('.js-header-menu.is-hover');
						if (prevHover && prevHover !== menu) {
							prevHover.classList.remove('is-hover');
						}
						// is-hoverを付与
						menu.classList.add('is-hover');
					});
				});
				header.addEventListener('mouseleave', (e) => {
					// すべてのjs-tab-contentからis-active/is-visibleを外す
					document.querySelectorAll('.header .js-tab-content').forEach(content => {
						content.classList.remove('is-active', 'is-visible');
					});
					// .js-header-menu.is-hover があれば外す
					const prevHover = document.querySelector('.js-header-menu.is-hover');
					if (prevHover) {
						prevHover.classList.remove('is-hover');
					}
					// .js-header-menuでis-activeなもののdata-targetを取得
					const activeMenu = document.querySelector('.js-header-menu.is-active');
					if (activeMenu) {
						const target = activeMenu.getAttribute('data-target');
						if (target) {
							document.querySelectorAll(`.header .js-tab-content[data-target="${target}"]`).forEach(content => {
								content.classList.add('is-active');
								setTimeout(() => content.classList.add('is-visible'), 10);
							});
						}
					}
				});
			}
		},
		closeSpHeaderNav() {
			const $header = document.querySelector('.header');
			const $hamburger = document.querySelector('.js-header-hamburger');
			const $nav = document.querySelector('.js-header-nav-sp');
			const $headerNav = document.querySelector('.header-nav');
			const $container = document.querySelector('.container');
			const $headerAdvancedWrap = document.querySelector('.header-advanced-wrap');

			const fixedOffContainer = () => {
				$container.style.position = 'static';
				let scrollTopNow = window.scrollY;
				window.scrollTo({ top: scrollTopNow });
				if ($headerAdvancedWrap) $headerAdvancedWrap.style.pointerEvents = '';
			};
			if ($nav.classList.contains(a)) {
				$nav.classList.remove(a);
				$hamburger.classList.remove(a);
				$header.classList.remove('is-open');
				$hamburger.ariaLabel = 'open'
				fixedOffContainer();
				if ($headerNav) $headerNav.classList.remove('is-hidden');
				if ($headerNav) $headerNav.style.pointerEvents = '';
			}
		},
		spHeaderHamburger() {
			const _this = this;
			if (document.querySelectorAll('.js-header-hamburger').length) {
				const $header = document.querySelector('.header');
				const $hamburger = document.querySelector('.js-header-hamburger');
				const $nav = document.querySelector('.js-header-nav-sp');
				const $headerNav = document.querySelector('.header-nav');
				const $container = document.querySelector('.container');
				const $headerAdvancedWrap = document.querySelector('.header-advanced-wrap');

				let scrollTopNow;
				const fixedOnContainer = () => {
					scrollTopNow = window.scrollY;
					$container.style.position = 'fixed';
					$container.style.width = '100%';
					$container.style.top = -1 * scrollTopNow;
					$container.style.left = 0;
					if ($headerAdvancedWrap) $headerAdvancedWrap.style.pointerEvents = 'none';
				};
				const fixedOffContainer = () => {
					$container.style.position = 'static';
					window.scrollTo({ top: scrollTopNow });
					if ($headerAdvancedWrap) $headerAdvancedWrap.style.pointerEvents = '';
				};
				$hamburger.addEventListener('click', (e) => {
					// 外部からも呼び出せるように関数化
					if ($nav.classList.contains(a)) {
						_this.closeSpHeaderNav();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						$hamburger.classList.add(a);
						$header.classList.add('is-open');
						$hamburger.ariaLabel = 'close';

						if ($headerNav) $headerNav.classList.add('is-hidden');
						if ($headerNav) $headerNav.style.pointerEvents = 'none';
					}
				});
				window.addEventListener("keydown", function (event) {
					if ($nav.classList.contains(a)) {
						// タブキーが押された時
						if (event.key === "Tab") {
							event.preventDefault();
							// ヘッダー内のフォーカス可能な要素を取得（display: none の要素を除外）
							const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
							let focusableElements = Array.from($header.querySelectorAll(focusableElementsSelector))
								.filter(el => el.offsetParent !== null); // 非表示要素を除外
							if (focusableElements.length === 0) return;
							// 現在のフォーカス位置を取得
							const focusedItemIndex = focusableElements.indexOf(document.activeElement);

							// shiftキーと同時に押されてた場合
							if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
							} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
							}
						}
						// ESCキーが押された時
						if (event.key === "Escape") {
							event.preventDefault();
							$nav.classList.remove(a);
							$hamburger.classList.remove(a);
							$header.classList.remove('is-open');
							$hamburger.ariaLabel = 'close'
							if ($headerNav) $headerNav.classList.remove('di_none');
							fixedOffContainer();
							$hamburger.focus({ preventScroll: true });
						}
					}
				});
			}
		},
		setHeaderAdvancedSearch() {
			//
			let suggestions = [];
			let suggestApiUrl = location.pathname.startsWith('/en/')
				? '/ajax/en/suggest/tag/list.json'
				: '/ajax/suggest/tag/list.json';

			fetch(suggestApiUrl)
				.then(res => res.json())
				.then(data => {
					if (data && Array.isArray(data.rt_bn_suggest_list)) {
						const isEnglish = location.pathname.startsWith('/en/');
						suggestions = data.rt_bn_suggest_list
							.map(item => {
								if (isEnglish && item.rt_cf_tt_name_d && item.rt_cf_tt_name_d.content) {
									return item.rt_cf_tt_name_d.content;
								} else if (!isEnglish && item.rt_cf_tt_name_d_jp && item.rt_cf_tt_name_d_jp.content) {
									return item.rt_cf_tt_name_d_jp.content;
								}
								return null;
							})
							.filter(Boolean);
					}
				})
				.catch(err => {
					console.error('Failed to load suggestions:', err);
				});

			let _this = this;
			const input = document.getElementById("header_search");
			const suggestionList = document.getElementById("suggestion-list");
			const closeBtn = document.getElementById("close-suggestions");
			const headerNavSub = document.querySelector(".header-nav-sub");
			const headerAdvancedWrap = document.querySelector(".header-advanced-wrap");
			const resetBtn = document.querySelector(".js-header-advanced-search-reset");
			const submitBtn = document.querySelector(".js-header-advanced-search-submit");
			const headerNav = document.querySelector(".header-nav");

			// 候補表示
			if (input && suggestionList) {
				let isComposing = false;

				// サジェスト処理の共通関数
				const processSuggestions = () => {

					const query = input.value.toLowerCase().trim();
					suggestionList.innerHTML = "";

					// ネイティブのサジェストを強制的に抑止
					input.setAttribute("readonly", true);
					setTimeout(() => {
						input.removeAttribute("readonly");
					}, 10);

					if (!query) {
						// 1024px以下でクエリが空の場合はis-activeを外す
						if (window.innerWidth <= 1024 && headerNavSub) {
							headerNavSub.classList.remove("is-active");
						}
						return;
					}
					const matches = suggestions.filter(item => item.toLowerCase().includes(query));

					// 1024px以下での特別処理
					if (window.innerWidth <= 1024 && headerNavSub) {
						if (matches.length > 0) {
							headerNavSub.classList.add("is-active");
						} else {
							headerNavSub.classList.remove("is-active");
						}
					}

					matches.forEach(match => {
						const li = document.createElement("li");
						li.textContent = match;
						li.addEventListener("click", () => {
							input.value = match;
							suggestionList.innerHTML = "";
							// クリック時もis-activeを外す
							if (window.innerWidth <= 1024 && headerNavSub) {
								headerNavSub.classList.remove("is-active");
							}
							keywordsubmitFunction();
						});
						suggestionList.appendChild(li);
					});

					_this.setElementHeight();
				};

				input.addEventListener("compositionstart", () => {
					isComposing = true;
				});

				input.addEventListener("compositionend", () => {
					isComposing = false;

					// 変換確定時にサジェストを実行
					setTimeout(() => {
						processSuggestions();
					}, 0);
				});

				input.addEventListener("input", () => {
					// 日本語入力中（IME変換中）は処理をスキップ

					if (isComposing) {
						return;
					}
					processSuggestions();
				});
			}

			// フォーカス時にis-activeクラスを追加
			if (input && headerNavSub && headerAdvancedWrap) {
				input.addEventListener("focus", () => {

					if (window.innerWidth <= 1024) {
					} else {
						headerNavSub.classList.add("is-active");
						headerAdvancedWrap.classList.add("is-active");
					}
				});
			}

			// ×ボタンでサジェスト非表示
			if (closeBtn && headerNavSub && headerAdvancedWrap) {
				closeBtn.addEventListener("click", () => {
					headerNavSub.classList.remove("is-active");

					if (window.innerWidth <= 1024) {
						suggestionList.innerHTML = "";
					} else {
						headerAdvancedWrap.classList.remove("is-active");
					}
					_this.setElementHeight();
				});
			}

			// 1024px以下でスクロール中は.header-navを非表示にし、scrollendで再表示
			if (headerNav) {
				let lastScrollY = window.scrollY;
				let ticking = false;

				const onScroll = () => {
					const currentY = Math.max(0, window.scrollY);
					const delta = currentY - lastScrollY;
					const isScrollingDown = delta > 2;
					const isScrollingUp = delta < -2;

					if (window.innerWidth <= 1024) {
						const spNav = document.querySelector('.header-nav-sp');
						const isSpNavActive = spNav && spNav.classList.contains('is-active');

						if (!isSpNavActive) {
							const isBodyFixed = document.body && document.body.style.position === 'fixed';
							if (!isBodyFixed) {
								if (isScrollingDown) {
									headerNav.classList.add('is-hidden'); // 下スクロール時は隠す
								} else if (isScrollingUp || currentY === 0) {
									headerNav.classList.remove('is-hidden'); // 上スクロール or 先頭で表示
								}
							}
						}
					} else {
						headerNav.classList.remove('is-hidden'); // PCは常に表示
					}

					lastScrollY = currentY;
					ticking = false;
				};

				window.addEventListener('scroll', () => {
					if (!ticking) {
						ticking = true;
						requestAnimationFrame(onScroll);
					}
				});
			}

			// ジャンル選択とこだわり選択表示
			document.querySelectorAll('.js-advanced-search-radio input[type="radio"]').forEach(radio => {
				radio.addEventListener('change', () => {
					const selectedId = radio.id;
					if (!selectedId) return;

					const header = document.querySelector('.header');
					if (!header) return;

					// ① .header 内の .__checkboxWrap から is-active を外す
					header.querySelectorAll('.__checkboxWrap.is-active').forEach(el => {
						el.classList.remove('is-active');
					});

					// ② .header 内の対象 .__checkboxWrap に is-active を追加
					const target = header.querySelector(`.__checkboxWrap[data-id="${selectedId}"]`);
					if (target) {
						target.classList.add('is-active');
					}
				});
			});
			const checked = document.querySelector('.js-advanced-search-radio input[type="radio"]:checked');
			if (checked) {
				const event = new Event('change');
				checked.dispatchEvent(event); // 初期化として強制発火
			}

			// こだわり検索input radio/checkbox判定
			document.querySelectorAll('.js-advanced-search-input-wrap .__checkboxWrap').forEach(wrap => {
				let count = 2;

				wrap.querySelectorAll('.mod-fieldset').forEach(fieldset => {
					const groupSelectElement = fieldset.querySelector('.rt_cf_ttm_group_select');
					if (groupSelectElement) {
						const groupSelectValue = groupSelectElement.textContent.trim();
						const isRadio = groupSelectValue === '0';
						// const isCheckbox = groupSelectValue === '1';

						// fieldset内のlabel.mod-checkboxを.mod-radioに変更
						const checkboxLabels = fieldset.querySelectorAll('label.mod-checkbox');
						checkboxLabels.forEach(label => {
							const checkboxText = label.querySelector('.mod-checkbox-text');
							const input = label.querySelector('input');
							const value = label.querySelector('.rt_cf_tt_key_search');
							if (isRadio) {
								label.classList.remove('mod-checkbox');
								label.classList.add('mod-radio');
								checkboxText.classList.remove('mod-checkbox-text');
								checkboxText.classList.add('mod-radio-text');
								input.type = 'radio';
							}
							input.name = 'p_tag_' + count;
							input.value = value ? value.textContent.trim() : '';
						});
						count++;
					}
				});
			});

			// リセットボタンのイベント
			if (resetBtn) {
				resetBtn.addEventListener("click", () => {
					// リセット処理
					// すべてのinputのチェックを外す
					document.querySelectorAll('.js-advanced-search-input-wrap .mod-fieldset input[type="checkbox"], .js-advanced-search-input-wrap .mod-fieldset input[type="radio"]').forEach(input => {
						input.checked = false;
					});

					// #header_searchのテキストを削除
					const headerSearchInput = document.getElementById('header_search');
					if (headerSearchInput) {
						headerSearchInput.value = '';
					}
				});
			}

			// 送信ボタンのイベント
			const keywordsubmitFunction = () => {
				let paramMap = new Map();
				// header_searchのテキストをp_keywordパラメータとして追加
				const headerSearchInput = document.getElementById('header_search');
				if (headerSearchInput && headerSearchInput.value.trim()) {
					paramMap.set('p_keyword', headerSearchInput.value.trim());
				}
				// MapをクエリパラメータのString配列に変換
				const queryParams = Array.from(paramMap.entries()).map(([name, value]) => `${name}=${value}`);
				const queryString = queryParams.join('&');

				// URL生成
				const basePath = location.pathname.startsWith('/en/') ? '/en/service/search/index.html' : '/service/search/index.html';
				const searchUrl = `${basePath}?${queryString}`;

				// ページ遷移
				window.location.href = searchUrl;
			}
			const submitFunction = () => {
				// 送信処理
				const activeCheckboxWraps = document.querySelector('.js-advanced-search-input-wrap > .is-active.__checkboxWrap');
				if (activeCheckboxWraps) {
					let paramMap = {};

					// header_searchのテキストをp_keywordパラメータとして追加
					const headerSearchInput = document.getElementById('header_search');
					if (headerSearchInput && headerSearchInput.value.trim()) {
						paramMap['p_keyword'] = [headerSearchInput.value.trim()];
					}

					// .js-advanced-search-radio内のチェックされたinputを取得してp_brandパラメータとして追加
					const checkedRadio = document.querySelector('.js-advanced-search-radio input[type="radio"]:checked');
					if (checkedRadio && checkedRadio.value) {
						paramMap['p_brand'] = [checkedRadio.value];
					}

					// .mod-fieldset内のチェックされたinputを取得
					const checkedInputs = activeCheckboxWraps.querySelectorAll('.mod-fieldset input[type="checkbox"]:checked, .mod-fieldset input[type="radio"]:checked');

					checkedInputs.forEach(input => {
						if (input.name && input.value) {
							if (!paramMap[input.name]) {
								paramMap[input.name] = [];
							}
							paramMap[input.name].push(input.value);
						}
					});

					// オブジェクトをクエリパラメータのString配列に変換
					const queryParams = [];
					Object.entries(paramMap).forEach(([name, values]) => {
						values.forEach(value => {
							queryParams.push(`${name}=${value}`);
						});
					});
					const queryString = queryParams.join('&');

					// URL生成
					const basePath = location.pathname.startsWith('/en/')
						? '/en/service/search/index.html'
						: '/service/search/index.html';
					const searchUrl = `${basePath}?${queryString}`;

					// ページ遷移
					window.location.href = searchUrl;
				}
			};

			if (submitBtn) {
				submitBtn.addEventListener("click", () => {
					// 送信処理
					submitFunction();
				});
			}
		},
		setAdvancedSearchHeight() {
			let _this = this;
			const $header = document.querySelector('.header');
			const $headerAdvancedSearchAccordion = document.querySelector('.js-header-advanced-search-accordion');

			let scrollY = 0;
			const isNarrow = () => window.innerWidth <= 1024;

			const lockBody = () => {
				if (document.body.style.position === 'fixed') return;
				scrollY = window.scrollY || document.documentElement.scrollTop || 0;
				document.body.style.position = 'fixed';
				document.body.style.top = `-${scrollY}px`;
				document.body.style.left = '0';
				document.body.style.right = '0';
				document.body.style.width = '100%';
			};
			const unlockBody = () => {
				if (document.body.style.position !== 'fixed') return;
				document.body.style.position = '';
				document.body.style.top = '';
				document.body.style.left = '';
				document.body.style.right = '';
				document.body.style.width = '';
				window.scrollTo(0, scrollY || 0);
			};

			// toggle時は1024以下のときだけ固定。閉じたら解除。
			if ($headerAdvancedSearchAccordion) {
				$headerAdvancedSearchAccordion.addEventListener('toggle', () => {
					if ($headerAdvancedSearchAccordion.open) {
						if (isNarrow()) {
							lockBody();
						}
					} else {
						unlockBody();
					}
				});
			}

			// 画面幅監視：1024超えたら固定解除。<=1024に戻って開いていれば固定し直し。
			const mq = window.matchMedia('(max-width: 1024px)');
			const onWidthChange = (e) => {
				if (!e.matches) {
					// now > 1024
					unlockBody();
				} else {
					// now <= 1024
					if ($headerAdvancedSearchAccordion?.open) {
						const y = window.scrollY || document.documentElement.scrollTop || 0;
						if (y >= 100) {
							lockBody();
						} else {
							unlockBody();
						}
					}
				}
			};
			if (mq.addEventListener) {
				mq.addEventListener('change', onWidthChange);
			} else if (mq.addListener) { // Safari
				mq.addListener(onWidthChange);
			}

			// 初期状態の整合
			if ($headerAdvancedSearchAccordion?.open) {
				if (isNarrow()) {
					lockBody();
				} else {
					unlockBody();
				}
			}

			if ($headerAdvancedSearchAccordion) {
				$headerAdvancedSearchAccordion.addEventListener('click', (e) => {
					setTimeout(() => {
						_this.setElementHeight();
					}, 500);
				});
			}
		},
		setElementHeight() {
			const headerInner = document.querySelector('.header-inner');
			const headerNav = document.querySelector('.header-nav');
			const accordionSummary = document.querySelector('.header-advanced-search > .js-accordion > .mod-accordion-summary');
			const radioWrap = document.querySelector('.__radioWrap');
			const btnWrap = document.querySelector('.__btnWrap');
			const searchScrollWrap = document.querySelector('.__searchScrollWrap');
			const suggestionList = document.querySelector('#suggestion-list');

			if (searchScrollWrap) {
				let totalHeight = 0;

				// Calculate total height of all elements
				if (headerInner) totalHeight += 80;
				if (headerNav) totalHeight += 80;
				if (accordionSummary) totalHeight += accordionSummary.offsetHeight;
				if (radioWrap) totalHeight += radioWrap.offsetHeight;
				if (btnWrap) totalHeight += btnWrap.offsetHeight;
				if (suggestionList) totalHeight += suggestionList.offsetHeight;

				// Set max-height as 100vh minus total height
				const maxHeight = `calc(100dvh - ${totalHeight}px)`;
				searchScrollWrap.style.maxHeight = maxHeight;
			}
		},
		setSpHeaderSlideMegaMenuEvent() {
			const items = document.querySelectorAll('.header-nav-sp-mega-layer button[data-target]');
			const backs = document.querySelectorAll('.header-nav-sp-mega-layer .back');

			items.forEach(item => {
				item.addEventListener('click', () => {
					const targetId = item.dataset.target;
					const currentLayer = item.closest('.header-nav-sp-mega-layer');
					const targetLayer = document.getElementById(targetId);

					currentLayer.classList.remove('active');
					currentLayer.classList.add('previous');
					targetLayer.classList.add('active');
				});
			});

			backs.forEach(button => {
				button.addEventListener('click', () => {
					const backId = button.dataset.back;
					const currentLayer = button.closest('.header-nav-sp-mega-layer');
					const backLayer = document.getElementById(backId) || document.querySelector(`.${backId}`);

					currentLayer.classList.remove('active');
					backLayer.classList.remove('previous');
					backLayer.classList.add('active');
				});
			});
		},
		setHeaderRestaurantListHeight() {
			const tabContents = document.querySelectorAll('.js-header-restaurant-tab-content');

			tabContents.forEach(tabContent => {
				const mv = tabContent.querySelector('.js-header-restaurant-mv');
				const list = tabContent.querySelector('.js-header-restaurant-list');

				if (mv && list) {
					const mvHeight = mv.offsetHeight;
					const parent = tabContent.closest('.__tabContent');
					const totalHeight = parent ? parent.offsetHeight : window.innerHeight;
					list.style.height = (totalHeight - mvHeight - 36) + 'px';
				}
			});
		},
		spTopicPathToggle() {
			if (document.getElementsByClassName('mod-topicPath-toggle').length) {
				document.getElementsByClassName('mod-topicPath-toggle')[0].addEventListener('click', () => {
					document.getElementsByClassName('mod-topicPath-ol')[0].classList.toggle('is-open');
				});
			}
		},
		setGalleryTagBtn() {
			const tagButtons = document.querySelectorAll('.js-gallery-tag');
			const galleryWrap = document.querySelector('.js-gallery-wrap');

			if (!tagButtons.length || !galleryWrap) return;

			tagButtons.forEach(button => {
				button.addEventListener('click', () => {
					// すべてのタグボタンからアクティブクラスを削除
					tagButtons.forEach(btn => btn.classList.remove('is-active'));

					// クリックされたボタンにアクティブクラスを追加
					button.classList.add('is-active');

					// タグキーを取得
					const tagKeyElement = button.querySelector('.rt_cf_n_tags_key');
					const selectedTagKey = tagKeyElement ? tagKeyElement.textContent.trim() : '';

					// ギャラリー画像をフィルタリング
					const galleryImages = document.querySelectorAll('.js-gallery-wrap .__img');

					galleryImages.forEach(img => {
						// すべてのクラスをリセット
						img.classList.remove('is-active', '__pcBorder', '__spBorder', 'is-hidden');

						if (selectedTagKey === '' || selectedTagKey === 'all') {
							// 全表示の場合
							img.classList.remove('is-hidden');
						} else {
							// 特定のタグでフィルタリング
							const imgTags = img.getAttribute('data-tags') || '';
							const imgTagArray = imgTags.split(',').map(tag => tag.trim());

							if (imgTagArray.includes(selectedTagKey)) {
								img.classList.remove('is-hidden');
							} else {
								img.classList.add('is-hidden');
							}
						}
					});

					// フィルタリング後にギャラリーの表示を再初期化
					this.resetGalleryDisplay();
				});
			});
		},
		resetGalleryDisplay() {
			const galleryImages = document.querySelectorAll('.js-gallery-wrap .__img:not(.is-hidden)');
			const moreButton = document.querySelector('.gallery-more-btn');

			if (!galleryImages.length) return;

			// すべての表示可能な画像からis-activeを削除
			galleryImages.forEach(img => {
				img.classList.remove('is-active', '__pcBorder', '__spBorder');
			});

			// 最初の10件（またはそれ以下）を表示
			const maxImagesToShow = Math.min(10, galleryImages.length);
			for (let i = 0; i < maxImagesToShow; i++) {
				galleryImages[i].classList.add('is-active');
			}

			// ボーダークラスを更新
			this.updateGalleryBorders();

			// もっと見るボタンの表示/非表示を制御
			if (moreButton) {
				if (galleryImages.length <= 10) {
					moreButton.style.display = 'none';
				} else {
					moreButton.style.display = 'block';
				}
			}

			// ギャラリーモーダルのdata-modal-idを再設定
			this.resetModalIds();
		},
		updateGalleryBorders() {
			const activeImages = document.querySelectorAll('.js-gallery-wrap .__img.is-active:not(.is-hidden)');
			const totalActive = activeImages.length;

			// ボーダークラスをリセット
			activeImages.forEach(img => {
				img.classList.remove('__pcBorder', '__spBorder');
			});

			// 最後の5個にPCボーダーを追加
			for (let i = Math.max(0, totalActive - 5); i < totalActive; i++) {
				activeImages[i].classList.add('__pcBorder');
			}

			// 最後の2個にSPボーダーを追加
			for (let i = Math.max(0, totalActive - 2); i < totalActive; i++) {
				activeImages[i].classList.add('__spBorder');
			}
		},
		resetModalIds() {
			// 表示中の画像のみにdata-modal-idを再設定（ギャラリーラップ内の要素＋スライダー内の要素も対象）
			const visibleGalleryElements = document.querySelectorAll('.js-gallery-wrap .__img:not(.is-hidden) .js-gallery-modal-open');
			const slideElements = document.querySelectorAll('.splide__slide:not(.splide__slide--clone) .js-gallery-modal-open');
			const allElements = [...slideElements, ...visibleGalleryElements];
			allElements.forEach((element, index) => {
				element.setAttribute('data-modal-id', index);
			});
		},
		createGalleryModal() {
			const galleryWrap = document.querySelector('.js-gallery-wrap');
			if (!galleryWrap) return;

			// ページパスに基づくAPIエンドポイントの設定
			const apiEndpoints = [
				{
					pattern: /^\/service\/product\/(.+)\/$/,
					getUrl: (match) => `/ajax/i2_gallery/${match[1]}/list.json`
				},
				{
					pattern: /^\/service\/restaurant\/([^\/]+)\/([^\/]+)\/$/,
					getUrl: (match) => `/ajax/g6_gallery/${match[2]}/list.json`
				},
				{
					pattern: /^\/service\/party\/([^\/]+)\/$/,
					getUrl: (match) => `/ajax/h2_gallery/${match[1]}/list.json`
				},
				{
					pattern: /^\/service\/party\/wedding\/$/,
					getUrl: () => `/ajax/h10_gallery/list.json`
				},
				{
					pattern: /^\/service\/party\/event\/$/,
					getUrl: () => `/ajax/h17_gallery/list.json`
				},
				// 英語版対応（enプレフィックス）
				{
					pattern: /^\/en\/service\/product\/(.+)\/$/,
					getUrl: (match) => `/ajax/i2_gallery/${match[1]}/list.json`
				},
				{
					pattern: /^\/en\/service\/restaurant\/([^\/]+)\/([^\/]+)\/$/,
					getUrl: (match) => `/ajax/g6_gallery/${match[2]}/list.json`
				},
				{
					pattern: /^\/en\/service\/party\/([^\/]+)\/$/,
					getUrl: (match) => `/ajax/h2_gallery/${match[1]}/list.json`
				},
				{
					pattern: /^\/en\/service\/party\/wedding\/$/,
					getUrl: () => `/ajax/h10_gallery/list.json`
				},
				{
					pattern: /^\/en\/service\/party\/event\/$/,
					getUrl: () => `/ajax/h17_gallery/list.json`
				}
			];

			// 現在のパスを取得
			const currentPath = location.pathname;

			// パスに対応するAPIエンドポイントを取得
			let apiUrl = null;
			for (const endpoint of apiEndpoints) {
				const match = currentPath.match(endpoint.pattern);
				if (match) {
					apiUrl = endpoint.getUrl(match);
					break;
				}
			}

			// Ajax でデータを取得
			fetch(apiUrl)
				.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}
					return response.json();
				})
				.then(json => {
					// JSONデータから.js-gallery-wrap内にギャラリー要素を生成
					if (json && json.rt_bn_news_list && json.rt_bn_news_list.length) {
						let galleryHTML = '';

						json.rt_bn_news_list.forEach((item, index) => {
							// 現在のパスが英語版かどうかを判定
							const isEnglishPath = location.pathname.startsWith('/en/');

							// 言語に応じて適切なフィールドを選択
							const imgSrc = isEnglishPath
								? (item.cf_n_img_en || '')
								: (item.cf_n_img_jp || '');
							const imgAlt = isEnglishPath
								? (item.cf_n_img_alt_en || '')
								: (item.cf_n_img_alt_jp || '');
							const imgTitle = isEnglishPath
								? (item.cf_n_img_title_en || '')
								: (item.cf_n_img_title_jp || '');
							const thumSrc = isEnglishPath
								? (item.cf_n_thum_img_en || '')
								: (item.cf_n_thum_img_jp || '');
							const thumAlt = isEnglishPath
								? (item.cf_n_thum_alt_en || '')
								: (item.cf_n_thum_alt_jp || '');
							const thumTitle = isEnglishPath
								? (item.cf_n_thum_title_en || '')
								: (item.cf_n_thum_title_jp || '');
							const caption = isEnglishPath
								? (item.cf_n_description_en || '')
								: (item.cf_n_description_jp || '');
							const movieId = isEnglishPath
								? (item.cf_n_video_id_en || '')
								: (item.cf_n_video_id_jp || '');

							// タグからキーを抽出
							const tagKeys = item.cf_n_tags ? item.cf_n_tags.map(tag => tag._key).join(',') : '';

							// imgSrcまたはthumSrcのどちらかを使用（imgSrcを優先）
							const displaySrc = imgSrc || thumSrc;
							const displayAlt = imgSrc ? imgAlt : thumAlt;
							const displayTitle = imgSrc ? imgTitle : thumTitle;

							// 画像パスの調整（必要に応じて）
							const fullImgSrc = displaySrc.startsWith('/') ? displaySrc : `/news_file/file/${displaySrc}`;
							const fullOriginalSrc = imgSrc ? (imgSrc.startsWith('/') ? imgSrc : `/news_file/file/${imgSrc}`) : fullImgSrc;

							galleryHTML += `
								<div class="__img" data-tags="${tagKeys}">
									<button class="js-gallery-modal-open">
										<figure>
											<img src="${fullImgSrc}" loading="lazy" alt="${displayAlt}" width="1920" height="1200">
										</figure>
										<span class="di_none js-gallery-prm-movie">${movieId}</span>
										<span class="di_none js-gallery-prm-imgSrc">${fullOriginalSrc}</span>
										<span class="di_none js-gallery-prm-imgAlt">${imgAlt || displayAlt}</span>
										<span class="di_none js-gallery-prm-imgTitle">${imgTitle || displayTitle}</span>
										<span class="di_none js-gallery-prm-caption">${caption}</span>
									</button>
								</div>
							`;
						});

						galleryWrap.innerHTML = galleryHTML;

						// 初期表示を設定
						this.resetGalleryDisplay();
						this.setGalleryModalEvent();
					} else {
						// .js-gallery-wrapの親要素を辿ってsectionを見つけてdisplay:noneにする
						const parentSection = galleryWrap.closest('section');
						console.warn('No gallery data found, hiding section.', parentSection);
						if (parentSection) {
							parentSection.style.display = 'none';
						}
					}
				})
				.catch(error => {
					console.error('Failed to load gallery data:', error);
				});
		},
		initGallerySlider(destroyOnlyFlag = false) {
			const galleryTarget = document.querySelector(".js-gallery-slider");

			if (!galleryTarget) return false;

			// 既存のSplideインスタンスがある場合は削除
			if (galleryTarget.splide) {
				galleryTarget.splide.destroy();
			}
			if (destroyOnlyFlag) {
				return
			}

			let splide = new Splide(galleryTarget, {
				type: "loop",
				arrows: true,
				fixedWidth: 700,
				fixedHeight: 700,
				focus: 'center',
				pagination: true,
				gap: 20,
				speed: 800,
				start: 0,
				trimSpace: false,
				breakpoints: {
					1024: {
						fixedWidth: 260,
						fixedHeight: 260,
						gap: 0,
						arrows: true,
					},
				}
			});

			splide.on('overflow', function (isOverflow) {
				splide.options = {
					arrows: isOverflow,
					drag: isOverflow,
				};
			});
			splide.mount();

			// カスタム is-active を先に付ける
			splide.on('move', (newIndex) => {
				const slides = splide.Components.Slides.get(); // 全スライドを取得
				const focus = splide.options.focus;

				let activeIndex;

				if (focus === 'center') {
					const perPage = splide.options.perPage || 1;
					const visibleCount = Math.min(perPage, slides.length);
					const offset = Math.floor(visibleCount / 2);
					activeIndex = newIndex + offset;
				} else if (typeof focus === 'number') {
					activeIndex = newIndex + focus;
				} else {
					activeIndex = newIndex; // focus: false や 'start' の場合
				}

				// 範囲超えを防ぐ
				activeIndex = Math.min(activeIndex, slides.length - 1);

				// 先に付け替える
				slides.forEach((slideObj, i) => {
					const slide = slideObj.slide;
					slide.classList.toggle('is-visible', i === activeIndex);
				});
			});
		},
		setGalleryModalEvent() {
			let _this = this;
			_this.initGallerySlider(true);
			// ページ内の.js-gallery-modal-open要素にdata-modaiIdを付与する（次の画像へ、前の画像へ用。連番で）
			const galleryElements = document.querySelectorAll('.js-gallery-modal-open');
			galleryElements.forEach((element, index) => {
				element.setAttribute('data-modal-id', index);
			});

			// ギャラリーモーダルの開閉処理
			galleryElements.forEach((element) => {
				element.addEventListener('click', (e) => {
					e.preventDefault();
					const currentIndex = parseInt(element.getAttribute('data-modal-id'));
					showGalleryModal(currentIndex);
				});
				_this.setGalleryMoreBtn();
			});

			_this.initGallerySlider();

			// ギャラリーモーダル表示関数
			const showGalleryModal = (currentIndex) => {
				// ギャラリーラップ内の表示中の要素とスライダー内の全要素を対象とする
				const galleryWrapElements = document.querySelectorAll('.js-gallery-wrap .__img:not(.is-hidden) .js-gallery-modal-open');
				const slideElements = document.querySelectorAll('.splide__slide:not(.splide__slide--clone) .js-gallery-modal-open');
				const allElements = [...slideElements, ...galleryWrapElements];

				if (currentIndex >= allElements.length) return;

				const modal = document.querySelector('.js-gallery-modal');
				const currentElement = allElements[currentIndex];
				const movieElement = currentElement.querySelector('.js-gallery-prm-movie');
				const imgSrcRaw = currentElement.querySelector('.js-gallery-prm-imgSrc')?.textContent;
				const imgAlt = currentElement.querySelector('.js-gallery-prm-imgAlt')?.textContent;
				const imgTitle = currentElement.querySelector('.js-gallery-prm-imgTitle')?.textContent;
				const caption = currentElement.querySelector('.js-gallery-prm-caption')?.textContent;

				// imgSrcの正しい形を保証する
				const imgSrc = imgSrcRaw && !imgSrcRaw.startsWith('/news_file/file/')
					? `/news_file/file/${imgSrcRaw}`
					: imgSrcRaw;

				// モーダル内の要素を更新
				// 動画の処理
				const modalMovie = modal.querySelector('.js-gallery-modal-movie iframe');
				const modalImg = modal.querySelector('.js-gallery-modal-img');
				const modalImgElement = modal.querySelector('.js-gallery-modal-img img');

				if (movieElement && movieElement.textContent.trim()) {
					// 動画がある場合
					const videoId = movieElement.textContent.trim();
					if (modalMovie) {
						modalMovie.src = `https://player.vimeo.com/video/${videoId}`;
					}
					// 画像を非表示にして動画を表示
					if (modalImg) modalImg.style.display = 'none';
					if (modal.querySelector('.js-gallery-modal-movie')) {
						modal.querySelector('.js-gallery-modal-movie').style.display = 'block';
					}
				} else {
					// 画像の場合
					if (imgSrc) {
						if (modalImgElement) modalImgElement.src = imgSrc;
					}
					if (imgAlt) {
						if (modalImgElement) modalImgElement.alt = imgAlt;
					}
					if (imgTitle) {
						if (modalImgElement) modalImgElement.title = imgTitle;
					}
					// 動画を非表示にして画像を表示
					if (modal.querySelector('.js-gallery-modal-movie')) {
						modal.querySelector('.js-gallery-modal-movie').style.display = 'none';
					}
					if (modalImg) modalImg.style.display = 'block';
				}

				// キャプションの処理
				const modalCaption = modal.querySelector('.js-gallery-modal-text');
				if (modalCaption) {
					modalCaption.textContent = caption || '';
				}

				if (modal) {
					modal.classList.add('is-visible');

					// イベントリスナーが重複して登録されないよう、一度クリアする
					const closeBtn = modal.querySelector('.js-gallery-modal-close');
					const prevBtn = modal.querySelector('.js-gallery-modal-prev');
					const nextBtn = modal.querySelector('.js-gallery-modal-next');

					// 既存のイベントリスナーを削除
					if (closeBtn) {
						closeBtn.replaceWith(closeBtn.cloneNode(true));
					}
					if (prevBtn) {
						prevBtn.replaceWith(prevBtn.cloneNode(true));
					}
					if (nextBtn) {
						nextBtn.replaceWith(nextBtn.cloneNode(true));
					}

					// 新しい要素を取得してイベントリスナーを登録
					const newCloseBtn = modal.querySelector('.js-gallery-modal-close');
					const newPrevBtn = modal.querySelector('.js-gallery-modal-prev');
					const newNextBtn = modal.querySelector('.js-gallery-modal-next');

					// モーダル内の情報をリセットする共通関数
					const resetModalContent = () => {
						const modalMovie = modal.querySelector('.js-gallery-modal-movie iframe');
						const modalImgElement = modal.querySelector('.js-gallery-modal-img img');
						const modalCaption = modal.querySelector('.js-gallery-modal-text');

						// 動画のソースをリセット
						if (modalMovie) {
							modalMovie.src = '';
						}

						// 画像の情報をリセット
						if (modalImgElement) {
							modalImgElement.src = '';
							modalImgElement.alt = '';
							modalImgElement.title = '';
						}

						// キャプションをリセット
						if (modalCaption) {
							modalCaption.textContent = '';
						}
					};

					if (newCloseBtn) {
						newCloseBtn.addEventListener('click', () => {
							resetModalContent();
							modal.classList.remove('is-visible');
						});
					}

					if (newPrevBtn) {
						newPrevBtn.addEventListener('click', () => {
							resetModalContent();
							const prevIndex = currentIndex === 0 ? allElements.length - 1 : currentIndex - 1;
							showGalleryModal(prevIndex);
						});
					}

					if (newNextBtn) {
						newNextBtn.addEventListener('click', () => {
							resetModalContent();
							const nextIndex = currentIndex === allElements.length - 1 ? 0 : currentIndex + 1;
							showGalleryModal(nextIndex);
						});
					}
				}
			};
		},
		setGalleryMoreBtn() {
			const galleryImgMore = () => {
				const moreButton = document.querySelector('.gallery-more-btn');
				if (!moreButton) return;

				// 既存のイベントリスナーを削除
				moreButton.replaceWith(moreButton.cloneNode(true));
				const newMoreButton = document.querySelector('.gallery-more-btn');

				newMoreButton.addEventListener('click', () => {
					// 表示中かつ非アクティブな画像を取得
					const inactiveImages = document.querySelectorAll('.js-gallery-wrap .__img:not(.is-hidden):not(.is-active)');

					const imagesToActivate = Math.min(10, inactiveImages.length);
					for (let i = 0; i < imagesToActivate; i++) {
						inactiveImages[i].classList.add('is-active');
					}

					// ボーダークラスを更新
					this.updateGalleryBorders();

					// モーダルIDを再設定
					this.resetModalIds();

					if (inactiveImages.length <= 10) {
						newMoreButton.style.display = 'none';
					}
				});
			}
			galleryImgMore();
		},
		initVideo() {
			// .js-video-wrapがあるかチェック
			const videoWraps = document.querySelectorAll('.js-video-wrap');
			if (videoWraps.length === 0) {
				return; // 何もしない
			}

			// Vimeo APIが読み込まれているかチェック
			if (typeof Vimeo === 'undefined' || typeof Vimeo.Player === 'undefined') {
				const script = document.createElement('script');
				script.src = 'https://player.vimeo.com/api/player.js';
				script.onload = () => {
					this.createVideoPlayers();
				};
				document.head.appendChild(script);
			} else {
				this.createVideoPlayers();
			}
		},
		createVideoPlayers() {
			// PC/SP判定用のブレークポイント（必要に応じて変更）
			const PC_QUERY = '(min-width: 768px)';

			const mql = window.matchMedia(PC_QUERY);
			const videoWraps = document.querySelectorAll('.js-video-wrap');

			videoWraps.forEach(initWrap);

			// 画面幅が変わったら必要なラッパーだけ切替（デバウンス付き）
			let resizeTimer;
			mql.addEventListener?.('change', () => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(() => {
					videoWraps.forEach(updateWrapIfNeeded);
				}, 120);
			});

			/** 初期化 */
			function initWrap(wrap) {
				wrap.__vimeo = wrap.__vimeo || { player: null, currentId: null };
				const idToUse = pickIdForWrap(wrap, mql.matches);
				mountOrSwapPlayer(wrap, idToUse);
				bindPlayToggle(wrap);
			}

			/** 画面幅変更時にIDが変わるなら差し替え */
			function updateWrapIfNeeded(wrap) {
				const idToUse = pickIdForWrap(wrap, mql.matches);
				if (idToUse && idToUse !== wrap.__vimeo.currentId) {
					mountOrSwapPlayer(wrap, idToUse);
				}
			}

			/** ラッパーからPC/SP用IDを取得 */
			function pickIdForWrap(wrap, isPC) {
				// 1) data属性があれば最優先
				const pc = wrap.dataset.videoPc || '';
				const sp = wrap.dataset.videoSp || '';
				// 2) 子要素の <span class="js-video-id" data-target="pc|sp"> も見る
				const spanPC = wrap.querySelector('.js-video-id[data-target="pc"]');
				const spanSP = wrap.querySelector('.js-video-id[data-target="sp"]');
				const single = wrap.querySelector('.js-video-id:not([data-target])');

				const pcId = (pc || spanPC?.textContent || '').trim();
				const spId = (sp || spanSP?.textContent || '').trim();

				if (pcId && spId) return isPC ? pcId : spId;      // 両方ある
				if (pcId || spId) return (pcId || spId);          // どちらかだけ
				if (single) return single.textContent.trim();     // 共通IDのみ
				return '';                                        // 何もない
			}

			/** プレイヤーを作成/差し替え */
			function mountOrSwapPlayer(wrap, videoId) {
				if (!videoId) return;

				// 既存プレイヤーの掃除
				if (wrap.__vimeo.player) {
					try { wrap.__vimeo.player.unload?.(); } catch (_) { }
					wrap.__vimeo.player = null;
				}
				const existingIframe = wrap.querySelector('iframe');
				if (existingIframe) existingIframe.remove();

				// iframe作成（A11y: title を分かりやすい文言に）
				const iframe = document.createElement('iframe');
				const params = new URLSearchParams({
					autoplay: '1',
					muted: '1',
					background: '1',
					loop: '1',
					title: '0',
					byline: '0',
					portrait: '0'
				});

				iframe.src = `https://player.vimeo.com/video/${videoId}?${params.toString()}`;
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share');
				iframe.setAttribute('allowfullscreen', '');
				iframe.setAttribute('playsinline', ''); // iOSでの挙動安定
				// title は data-title があればそれを、無ければ近くの見出しテキストを利用
				const explicitTitle = wrap.dataset.title || wrap.querySelector('h1,h2,h3,h4,h5,h6')?.textContent?.trim();
				iframe.title = explicitTitle ? `${explicitTitle}（動画）` : '動画コンテンツ（Vimeo）';

				wrap.appendChild(iframe);

				// Vimeo Player API
				if (window.Vimeo?.Player) {
					const player = new Vimeo.Player(iframe);
					// 念のためミュート & 再生
					player.setVolume(0).catch(() => { });
					player.play().catch(() => { });
					wrap.__vimeo.player = player;
				}

				wrap.__vimeo.currentId = videoId;
			}

			/** 再生/一時停止ボタン */
			function bindPlayToggle(wrap) {
				const btn = wrap.querySelector('.__videoControl');
				if (!btn) return;
				btn.addEventListener('click', () => {
					const player = wrap.__vimeo.player;
					if (!player) return;
					player.getPaused().then((paused) => {
						if (paused) {
							player.play();
							btn.classList.remove('is-paused');
							btn.setAttribute('aria-pressed', 'false');
						} else {
							player.pause();
							btn.classList.add('is-paused');
							btn.setAttribute('aria-pressed', 'true');
						}
					});
				});
				// キーボードでも押せるよう aria を付与
				btn.setAttribute('type', 'button');
				btn.setAttribute('aria-pressed', 'false');
				btn.setAttribute('aria-label', '動画の再生/一時停止');
			}
		},
		setShopInfoLink() {
			const shopLinkWraps = document.querySelectorAll('.js-shop-info-link-wrap');
			if (shopLinkWraps.length > 0) {
				shopLinkWraps.forEach((wrap, index) => {
					const tenpoKeyElement = wrap.querySelector('.rt_cf_n_tenpo_key');
					if (tenpoKeyElement) {
						const tenpoId = tenpoKeyElement.textContent.trim();
						if (tenpoId) {
							const apiUrl = `/ajax/related/tenpo/${tenpoId}.json`;
							// JSONから店舗情報を取得
							fetch(apiUrl)
								.then(response => {
									return response.json();
								})
								.then(data => {
									if (data && data.rt_bn_tenpo_info && data.rt_bn_tenpo_info.length > 0) {
										const tenpoInfo = data.rt_bn_tenpo_info[0];
										if (tenpoInfo.cf_t_brand && tenpoInfo.cf_t_brand.cf_tb_group_code && tenpoInfo.cf_t_brand.cf_tb_code) {
											let url = '';
											const groupCode = tenpoInfo.cf_t_brand.cf_tb_group_code;
											const brandCode = tenpoInfo.cf_t_brand.cf_tb_code;
											// URL生成の分岐処理
											switch (groupCode) {
												case 'res':
													url = `/service/restaurant/${brandCode}/${tenpoId}/`;
													break;
												case 'wed':
													url = `/service/party/${tenpoId}/`;
													break;
												case 'prod':
													url = `/service/product/${brandCode}/${tenpoId}.html`;
													break;
												default:
													console.warn('Unknown group code:', groupCode);
													return;
											}
											
											// 生成したURLを対応するリンクに設定
											const shopLinks = wrap.querySelectorAll('.js-shop-info-link-wrap .js-shop-info-link');
											shopLinks.forEach((link, linkIndex) => {
												link.href = url;
											});
										} else {
											console.warn('Missing brand information in tenpo info');
										}
									} else {
										console.warn('No tenpo info found in response');
									}
								})
								.catch(error => {
									console.error('Failed to load shop info:', error);
								});
						} else {
							console.warn('Empty tenpo ID');
						}
					} else {
						console.warn('Tenpo key element not found in wrap');
					}
				});
			}
		},
		setHeaderLangLink() {
			const langLinksEn = document.querySelectorAll('.js-header-lang-link-en');
			if (langLinksEn.length) {
				const langStatus = document.querySelector('.js-header-lang-status');
				let status = langStatus ? langStatus.textContent.trim() : '';
				let newHref = '';
				if (status === '' || status === '1') {
					let path = location.pathname;
					if (!path.startsWith('/en/')) {
						path = '/en' + (path.startsWith('/') ? '' : '/') + path;
					}
					newHref = path + location.search + location.hash;
				} else if (status === '0') {
					newHref = '/en/';
				}
				if (newHref) {
					langLinksEn.forEach(link => link.setAttribute('href', newHref));
				}

			}

			const langLinksJp = document.querySelectorAll('.js-header-lang-link-jp');
			if (langLinksJp.length) {
				const currentUrl = location.pathname + location.search + location.hash;
				let newHref = currentUrl.replace(/^\/en\//, '/');
				if (newHref === '//') newHref = '/';
				langLinksJp.forEach(link => link.setAttribute('href', newHref));

			}
		},
		loadDelayScript() {
			let _this = this;
			_this.accordion();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.URLcurrent();
			_this.addClassHeader();
			_this.pcHeaderMegamenu();
			_this.spHeaderHamburger();
			_this.setHeaderAdvancedSearch();
			_this.setSpHeaderSlideMegaMenuEvent();
			_this.setHeaderRestaurantListHeight();
			_this.spTopicPathToggle();
			_this.setGalleryTagBtn();
			_this.createGalleryModal();
			_this.setShopInfoLink();
			_this.initVideo();

			_this.setAdvancedSearchHeight();
			_this.setHeaderLangLink();

			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
				resizeTime = setTimeout(() => { _this.setHeaderRestaurantListHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
